// https://github.com/dmarcelino/uuid-base62
// Modified to use uuid
const uuid = require( 'uuid' );
const baseX = require( 'base-x' );

const base62 = baseX( '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ' )

// expose node-uuid and baseX for convenience
module.exports.uuid = uuid;
module.exports.baseX = baseX;
module.exports.customBase = base62;
module.exports.length = 22;
module.exports.uuidLength = 32;

/**
 * @function v4 creates a random UUID
 */
module.exports.v4 = function v4() {
  const self = this;
  const args = Array.prototype.slice.call( arguments ); /* eslint-disable-line */

  if ( !args[1] ) {
    // make sure we use a buffer to avoid getting an uuid with dashes
    args[1] = Buffer.alloc( 16 );
  }

  const id = uuid.v4.apply( self, args );
  return self.encode( id );
};

/**
 * @function v1 create a random UUID
 */
module.exports.v1 = function v1() {
  const self = this;
  const args = Array.prototype.slice.call( arguments ); /* eslint-disable-line */

  if ( !args[1] ) {
    // make sure we use a buffer to avoid getting an uuid with dashes
    args[1] = Buffer.alloc( 16 );
  }

  const id = uuid.v1.apply( self, args );
  return self.encode( id );
};

/**
 * @function encode encodes the input with the provided encode method
 * @param input - the input to be encoded
 * @param encoding - the method to encode the input with 
 */
module.exports.encode = function encode( input, encoding ) {
  encoding = encoding || 'hex';
  
  if ( typeof input === 'string' ) {
    // remove the dashes to save some space
    input = Buffer.from( input.replace( /-/g, '' ), encoding );
  }
  return ensureLength( this.customBase.encode( input ), module.exports.length );
};

/**
 * @function decode decodes the encoded data with the encoding method
 * @param b62Str - encoded data to be decoded
 * @param encoding - the method to encode the input with 
 */
module.exports.decode = function decode( b62Str, encoding ) {
  encoding = encoding || 'hex';
  let res = ensureLength( Buffer.from( this.customBase.decode( b62Str ) ).toString( encoding ), module.exports.uuidLength );
  
  // re-add the dashes so the result looks like an uuid
  const resArray = res.split( '' );
  [ 8, 13, 18, 23 ].forEach( ( idx ) => {
    resArray.splice( idx, 0, '-' );
  } );
  res = resArray.join( '' );

  return res;
};

/**
 * @function ensureLength adds or removes '0's to the string to ensure the length
 * @param {string} str - the string to be manipulated
 * @param {number} maxLen - the length to force the string to
 * 
 * @api private
 */
function ensureLength( str, maxLen ) {
  str += '';
  if ( str.length < maxLen ) {
    return padLeft( str, maxLen );
  }
  if ( str.length > maxLen ) {
    return trimLeft( str, maxLen );
  }
  return str;
}

/**
 * @function padLeft adds '0's to the beginning of the string
 * 
 * @api private
 */
function padLeft( str, padding ) {
  str += '';
  let pad = '';
  for ( let i = str.length; i < padding; i++ ) {
    pad += '0';
  }
  return pad + str;
}

/**
 * @function trimLeft removes '0's from the beginning of the string
 * 
 * @api private
 */
function trimLeft( str, maxLen ) {
  str += '';
  let trim = 0;
  while ( str[trim] === '0' && ( str.length - trim ) > maxLen ) {
    trim++;
  }
  return str.slice( trim );
}
